import { render, staticRenderFns } from "./SchedulesTransportCard.vue?vue&type=template&id=58f0ebd5&"
import script from "./SchedulesTransportCard.vue?vue&type=script&lang=js&"
export * from "./SchedulesTransportCard.vue?vue&type=script&lang=js&"
import style0 from "./SchedulesTransportCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports